// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.software-development-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 70px;
    background-color:#fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    gap: 20px;
}

/* Left Section - Image */
.software-development-image {
    position: relative;
    width: 34%;
    order: 1; /* Place image on the left */
    margin-top: 0;
}



/* Right Section - Content */
.software-development-text {
    width: 60%;
    order: 2; /* Place content on the right */
    margin-bottom: 90px;
}

.software-development-text h1 {
    font-size: 2em;
    color: #000;
    margin-bottom: 10px;
}

.software-development-text p {
    font-size: 1em;
    color: #555;
    margin-bottom: 20px;
}

.services-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    list-style: none;
    padding: 0;
}

.services-list li {
    width: 45%;
    font-size: 0.9em;
    color: #333;
}

/* Button */
.software-development-button {
    background-color: #00c853;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 1em;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 20px;
    transition: background-color 0.3s ease;
}

.software-development-button:hover {
    background-color: #009624;
}

/* Responsive Design */
@media (max-width: 768px) {
    .software-development-container {
        flex-direction: column; /* Stack items for smaller screens */
        align-items: center;
        text-align: left;
        padding-top:150px;
        gap: 20px;
    }

    .software-development-text {
        width: 130%;
        margin-top:-30px;
        order: 2; /* Maintain order for responsive layout */
    }

    .software-development-text h1 {
        margin-top:20px;
        width: 125%;
        font-size: 180%;
        order: 2; /* Maintain order for responsive layout */
    }

    .software-development-image {
        width: 130%;
        order: 1; /* Maintain order for responsive layout */
    }

    .services-list li {
        width: 100%;
    }
}


/* Media Query for 1366x768 screen size */
@media screen and (min-width: 1380px) and (max-width: 1919px) {
    .software-development-container {
        padding: 100px; /* Adjusted padding for medium screens */
        gap: 15px; /* Reduced gap for tighter layout */
    }

    .software-development-text {
        margin-bottom: 100px; /* Adjust spacing for better alignment */
        margin-right: 30px;
    }

    .software-development-text h1 {
        font-size: 1.8em; /* Slightly smaller headline font size */
    }

    .software-development-text p {
        font-size: 0.95em; /* Adjusted font size for readability */
    }

    .software-development-image {
        width: 31%; /* Adjusted image width for proportional layout */
    }

    .services-list li {
        width: 48%; /* Adjust list item width to fit layout */
        font-size: 0.85em; /* Reduced font size */
    }

    .software-development-button {
        padding: 8px 18px; /* Reduced button size */
        font-size: 0.95em;
    }
}

/* Media Query for 1920x1080 screen size */
@media screen and (min-width: 1920px) {
    .software-development-container {
        padding: 80px; /* Increased padding for larger screens */
        gap: 25px; /* Enhanced gap for spacious layout */
    }

    .software-development-text {
        margin-bottom: 100px; /* Increased spacing for content */
    }

    .software-development-text h1 {
        font-size: 2.2em; /* Larger headline font size for better visual appeal */
    }

    .software-development-text p {
        font-size: 1.1em; /* Increased font size for readability */
    }

    .software-development-image {
        width: 32%; /* Reduced image width for balanced layout */
    }

    .services-list li {
        width: 45%; /* Consistent width for larger screens */
        font-size: 1em; /* Larger font size for improved readability */
    }

    .software-development-button {
        padding: 12px 24px; /* Larger button size for emphasis */
        font-size: 1.1em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SoftwareDevelopment/SoftwareDevelopment.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,wCAAwC;IACxC,SAAS;AACb;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAE,4BAA4B;IACtC,aAAa;AACjB;;;;AAIA,4BAA4B;AAC5B;IACI,UAAU;IACV,QAAQ,EAAE,+BAA+B;IACzC,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,WAAW;AACf;;AAEA,WAAW;AACX;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB,EAAE,oCAAoC;QAC5D,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,QAAQ,EAAE,yCAAyC;IACvD;;IAEA;QACI,eAAe;QACf,WAAW;QACX,eAAe;QACf,QAAQ,EAAE,yCAAyC;IACvD;;IAEA;QACI,WAAW;QACX,QAAQ,EAAE,yCAAyC;IACvD;;IAEA;QACI,WAAW;IACf;AACJ;;;AAGA,yCAAyC;AACzC;IACI;QACI,cAAc,EAAE,wCAAwC;QACxD,SAAS,EAAE,mCAAmC;IAClD;;IAEA;QACI,oBAAoB,EAAE,wCAAwC;QAC9D,kBAAkB;IACtB;;IAEA;QACI,gBAAgB,EAAE,wCAAwC;IAC9D;;IAEA;QACI,iBAAiB,EAAE,uCAAuC;IAC9D;;IAEA;QACI,UAAU,EAAE,iDAAiD;IACjE;;IAEA;QACI,UAAU,EAAE,yCAAyC;QACrD,iBAAiB,EAAE,sBAAsB;IAC7C;;IAEA;QACI,iBAAiB,EAAE,wBAAwB;QAC3C,iBAAiB;IACrB;AACJ;;AAEA,0CAA0C;AAC1C;IACI;QACI,aAAa,EAAE,yCAAyC;QACxD,SAAS,EAAE,qCAAqC;IACpD;;IAEA;QACI,oBAAoB,EAAE,kCAAkC;IAC5D;;IAEA;QACI,gBAAgB,EAAE,uDAAuD;IAC7E;;IAEA;QACI,gBAAgB,EAAE,wCAAwC;IAC9D;;IAEA;QACI,UAAU,EAAE,4CAA4C;IAC5D;;IAEA;QACI,UAAU,EAAE,wCAAwC;QACpD,cAAc,EAAE,8CAA8C;IAClE;;IAEA;QACI,kBAAkB,EAAE,oCAAoC;QACxD,gBAAgB;IACpB;AACJ","sourcesContent":["/* Main container */\n.software-development-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 70px;\n    background-color:#fff;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    gap: 20px;\n}\n\n/* Left Section - Image */\n.software-development-image {\n    position: relative;\n    width: 34%;\n    order: 1; /* Place image on the left */\n    margin-top: 0;\n}\n\n\n\n/* Right Section - Content */\n.software-development-text {\n    width: 60%;\n    order: 2; /* Place content on the right */\n    margin-bottom: 90px;\n}\n\n.software-development-text h1 {\n    font-size: 2em;\n    color: #000;\n    margin-bottom: 10px;\n}\n\n.software-development-text p {\n    font-size: 1em;\n    color: #555;\n    margin-bottom: 20px;\n}\n\n.services-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    list-style: none;\n    padding: 0;\n}\n\n.services-list li {\n    width: 45%;\n    font-size: 0.9em;\n    color: #333;\n}\n\n/* Button */\n.software-development-button {\n    background-color: #00c853;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 1em;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 20px;\n    transition: background-color 0.3s ease;\n}\n\n.software-development-button:hover {\n    background-color: #009624;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .software-development-container {\n        flex-direction: column; /* Stack items for smaller screens */\n        align-items: center;\n        text-align: left;\n        padding-top:150px;\n        gap: 20px;\n    }\n\n    .software-development-text {\n        width: 130%;\n        margin-top:-30px;\n        order: 2; /* Maintain order for responsive layout */\n    }\n\n    .software-development-text h1 {\n        margin-top:20px;\n        width: 125%;\n        font-size: 180%;\n        order: 2; /* Maintain order for responsive layout */\n    }\n\n    .software-development-image {\n        width: 130%;\n        order: 1; /* Maintain order for responsive layout */\n    }\n\n    .services-list li {\n        width: 100%;\n    }\n}\n\n\n/* Media Query for 1366x768 screen size */\n@media screen and (min-width: 1380px) and (max-width: 1919px) {\n    .software-development-container {\n        padding: 100px; /* Adjusted padding for medium screens */\n        gap: 15px; /* Reduced gap for tighter layout */\n    }\n\n    .software-development-text {\n        margin-bottom: 100px; /* Adjust spacing for better alignment */\n        margin-right: 30px;\n    }\n\n    .software-development-text h1 {\n        font-size: 1.8em; /* Slightly smaller headline font size */\n    }\n\n    .software-development-text p {\n        font-size: 0.95em; /* Adjusted font size for readability */\n    }\n\n    .software-development-image {\n        width: 31%; /* Adjusted image width for proportional layout */\n    }\n\n    .services-list li {\n        width: 48%; /* Adjust list item width to fit layout */\n        font-size: 0.85em; /* Reduced font size */\n    }\n\n    .software-development-button {\n        padding: 8px 18px; /* Reduced button size */\n        font-size: 0.95em;\n    }\n}\n\n/* Media Query for 1920x1080 screen size */\n@media screen and (min-width: 1920px) {\n    .software-development-container {\n        padding: 80px; /* Increased padding for larger screens */\n        gap: 25px; /* Enhanced gap for spacious layout */\n    }\n\n    .software-development-text {\n        margin-bottom: 100px; /* Increased spacing for content */\n    }\n\n    .software-development-text h1 {\n        font-size: 2.2em; /* Larger headline font size for better visual appeal */\n    }\n\n    .software-development-text p {\n        font-size: 1.1em; /* Increased font size for readability */\n    }\n\n    .software-development-image {\n        width: 32%; /* Reduced image width for balanced layout */\n    }\n\n    .services-list li {\n        width: 45%; /* Consistent width for larger screens */\n        font-size: 1em; /* Larger font size for improved readability */\n    }\n\n    .software-development-button {\n        padding: 12px 24px; /* Larger button size for emphasis */\n        font-size: 1.1em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
